/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GetGcsServiceAgentResponse {
  /**
  * The GCS service agent email for the scanning account\'s project. This service account needs cloudkms.cryptoKeyEncrypterDecrypter role to use CMEK for bucket encryption.
  */
  'gcsServiceAgent': string;
  /**
  * The Eon scanning service account email that needs cloudkms.cryptoKeyEncrypterDecrypter role to verify CMEK permissions during vault creation.
  */
  'scanningServiceAccount': string;
  /**
  * The vault account\'s service account email that manages the vault bucket and needs cloudkms.cryptoKeyEncrypterDecrypter role.
  */
  'vaultServiceAccount'?: string;
  /**
  * List of restore service account emails that need cloudkms.cryptoKeyDecrypter role to read backup data from the vault during restore operations.
  */
  'restoreServiceAccounts'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "gcsServiceAgent",
      "baseName": "gcsServiceAgent",
      "type": "string",
      "format": ""
    },
    {
      "name": "scanningServiceAccount",
      "baseName": "scanningServiceAccount",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultServiceAccount",
      "baseName": "vaultServiceAccount",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreServiceAccounts",
      "baseName": "restoreServiceAccounts",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetGcsServiceAgentResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

